<template>
  <section data-test="filter-problem-section">
    <div>
      <h4 class="text-base font-normal leading-none text-theme-33">
        สภาพปัญหา
      </h4>
    </div>
    <div class="flex mt-2">
      <div class="mr-1">
        <CheckboxIconButton
          icon="HeartIcon"
          id="heart-checkbox"
          v-model="modelValueComputed"
          value="ปัญหาด้านสุขภาพ"
          tooltip="ปัญหาด้านสุขภาพ"
        />
      </div>
      <div class="mr-1">
        <CheckboxIconButton
          icon="HomeIcon"
          id="home-checkbox"
          v-model="modelValueComputed"
          value="ปัญหาด้านครัวเรือน"
          tooltip="ปัญหาด้านครัวเรือน"
        />
      </div>
      <div class="mr-1">
        <CheckboxIconButton
          icon="DollarSignIcon"
          id="dollar-checkbox"
          v-model="modelValueComputed"
          value="ปัญหาด้านการเงิน"
          tooltip="ปัญหาด้านการเงิน"
        />
      </div>
      <div class="mr-1">
        <CheckboxIconButton
          icon="PackageIcon"
          v-model="modelValueComputed"
          id="package-checkbox"
          value="ปัญหาด้านการเข้าถึงสิทธิ"
          tooltip="ปัญหาด้านการเข้าถึงสิทธิ"
        >
          <img
            src="@/assets/images/icon/id-card.png"
            alt="id-card-icon"
            class="w-4 h-4"
          />
        </CheckboxIconButton>
      </div>
      <div>
        <CheckboxIconButton
          icon="BookOpenIcon"
          v-model="modelValueComputed"
          id="education-checkbox"
          value="ปัญหาด้านการศึกษา"
          tooltip="ปัญหาด้านการศึกษา"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import CheckboxIconButton from "../../base/checkbox-icon-button/index.vue";

const props = defineProps({
  modelValue: Array,
});
const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits("update:modelValue", val);
  },
});
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: none;
}
</style>
